import { render, staticRenderFns } from "./SlglrsMUTG_OverviewPage.vue?vue&type=template&id=7d65222e&"
import script from "./SlglrsMUTG_OverviewPage.vue?vue&type=script&lang=js&"
export * from "./SlglrsMUTG_OverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./SlglrsMUTG_OverviewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports